import { render, staticRenderFns } from "./EffectTypesTable.vue?vue&type=template&id=171048f8&"
import script from "./EffectTypesTable.vue?vue&type=script&lang=js&"
export * from "./EffectTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports